var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.state === '')?[_c('transactions-list')]:(_vm.state === 'loading')?[_vm._m(0)]:_vm._e()],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-f f-1 ai-c jc-c"},[_c('div',{staticClass:"loading-spinner large"})])
}]

export { render, staticRenderFns }